// import './style.scss';

/* eslint-disable indent */
import { getDetail, getGeneralProjectProposalInfo } from 'apis/midtermReviews.api';
// eslint-disable-next-line import/no-cycle
import { Detail } from 'features/MidtermReview/components';
import { useEffect, useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import {
  useLocation,
  // useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import Loading from 'components/Loading';
import { useTranslation } from 'react-i18next';
import { TabPanel, TabView } from 'primereact/tabview';
import { ProjectProposalDefenseDetail } from 'features/ProjectProposalDefense/pages';
import { getSummaryReport, downloadFileReport } from 'apis/summaryReport';
import ReviewFormMidtermAcceptance from 'features/Project/components/ReviewFormMidtermAcceptance';
import DynamicMidtermForm from 'features/MidtermReview/components/DynamicMidtermForm';
import { is1593 } from 'utils/func';
import GeneralCouncilInfo from 'features/Council/components/GeneralInfo';

export default function MidtermReviewFormDetail() {
  const { projectProposalId } = useParams();
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const [searchParams] = useSearchParams();
  const councilId = searchParams.get('councilId');
  const councilMemberId = searchParams.get('councilMemberId');
  const summaryReportId = searchParams.get('summaryReportId');

  const location = useLocation();
  const { isViewCouncilData } = location?.state || { isViewCouncilData: false };

  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);

  const {
    // handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
  });
  const { isDirty, dirtyFields } = useFormState({ control });

  const { ...formOptions } = useForm({
    mode: 'onChange',
  });

  const {
    error: errorRes,
    isError: isErrorRes,
    isLoading: isLoadingCreate,
  } = useMutation(() => true);

  const { data: midtermReviewData, isLoading: isLoadingMidtermReview } = useQuery(
    ['midterm-review'],
    () => getDetail(councilMemberId, councilId, projectProposalId)
  );

  const midtermReviews = useMemo(() => midtermReviewData?.data?.midtermReview, [midtermReviewData]);

  const { data: _summaryReport } = useQuery(
    ['midtermSummaryReport', summaryReportId],
    () => getSummaryReport(summaryReportId),
    {
      enabled: summaryReportId !== null,
    }
  );

  const summaryReport = useMemo(() => _summaryReport?.data, [_summaryReport]);

  const { mutate: mutateDownloadFile } = useMutation(downloadFileReport);

  const { data: dataGeneralProjectProposalInfo, isLoading: isLoadingProjectProposal } = useQuery(
    ['midterm-review', 'project-proposal', councilId, projectProposalId],
    ({ queryKey: [, , _councilId, _projectProposalId] }) =>
      getGeneralProjectProposalInfo(_councilId, _projectProposalId)
  );

  const template = useMemo(
    () => dataGeneralProjectProposalInfo?.data?.template,
    [dataGeneralProjectProposalInfo]
  );

  const handleDownloadFile = (filename, fileNameFormat = '') => {
    mutateDownloadFile(
      {
        summaryReportId,
        filename,
      },
      {
        onSuccess: async (res) => {
          if (res?.data) {
            const file = new Blob([res.data]);

            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = fileNameFormat || filename;

            link.click();
          }
        },
      }
    );
  };

  useEffect(() => {
    setValue('reviewResearchPlan', midtermReviews?.reviewResearchPlan);
    setValue('reviewProduct', midtermReviews?.reviewProduct);
    setValue('reviewProgress', midtermReviews?.reviewProgress);
    setValue('reviewExpenditureUsed', midtermReviews?.reviewExpenditureUsed);
    setValue('reviewContinueAbility', midtermReviews?.reviewContinueAbility);
    setValue('otherReview', midtermReviews?.otherReview);
    setValue('requestStop', midtermReviews?.requestStop);
    setValue('requestStopReason', midtermReviews?.requestStopReason);
    setValue('requestContinue', midtermReviews?.requestContinue);
    setValue('requestContinueModify', midtermReviews?.requestContinueModify);
    setValue('evaluate.evaluateResearchPlan.isQualified', midtermReviews?.evaluateResearchPlan);
    setValue('evaluate.evaluateResearchResult.isQualified', midtermReviews?.evaluateResearchResult);
    setValue('evaluate.evaluateProgress.isQualified', midtermReviews?.evaluateProgress);
    setValue(
      'evaluate.evaluateExpenditureUsed.isQualified',
      midtermReviews?.evaluateExpenditureUsed
    );
    setValue('evaluate.evaluateGeneral.isQualified', midtermReviews?.evaluateGeneral);
    setValue('evaluate.evaluateResearchPlan.isNotQualified', !midtermReviews?.evaluateResearchPlan);
    setValue(
      'evaluate.evaluateResearchResult.isNotQualified',
      !midtermReviews?.evaluateResearchResult
    );
    setValue('evaluate.evaluateProgress.isNotQualified', !midtermReviews?.evaluateProgress);
    setValue(
      'evaluate.evaluateExpenditureUsed.isNotQualified',
      !midtermReviews?.evaluateExpenditureUsed
    );
    setValue('evaluate.evaluateGeneral.isNotQualified', !midtermReviews?.evaluateGeneral);
  }, [midtermReviews]);

  const renderFirstTab = () => {
    if (is1593(template) || isLoadingProjectProposal) {
      return (
        <DynamicMidtermForm
          projectProposalId={projectProposalId}
          councilId={councilId}
          councilMemberId={councilMemberId}
          generalInfo={dataGeneralProjectProposalInfo?.data}
          isLoading={isLoadingProjectProposal}
          readOnly
          formOptions={formOptions}
        />
      );
    }
    return (
      <Detail
        isLoadingCreate={isLoadingCreate || isLoadingProjectProposal}
        isErrorRes={isErrorRes}
        errorRes={errorRes}
        // handleSubmit={handleSubmit}
        // onSubmit={onSubmit}
        control={control}
        watch={watch}
        setValue={setValue}
        getValues={getValues}
        isDirty={isDirty}
        dirtyFields={dirtyFields}
        errors={errors}
        // isValid
        reset={reset}
        isVisibleErrorDialog={isVisibleErrorDialog}
        setIsVisibleDialogError={setIsVisibleDialogError}
      />
    );
  };
  // #endregion

  return (
    <>
      {isLoadingCreate && isLoadingMidtermReview && <Loading />}

      <TabView activeIndex={tab} onTabChange={(e) => setTab(e.index)}>
        <TabPanel header={t('council.review.createOrUpdate')} leftIcon="pi pi-file mr-2">
          {renderFirstTab()}
        </TabPanel>
        <TabPanel header={t('council.review.detailProjectProposal')} leftIcon="pi pi-list mr-2">
          <ProjectProposalDefenseDetail />
        </TabPanel>
        <TabPanel header="Báo cáo giữa kỳ" leftIcon="pi pi-list mr-2">
          <ReviewFormMidtermAcceptance
            summaryReport={summaryReport}
            handleDownloadFile={handleDownloadFile}
            control={control}
            errors={errors}
          />
        </TabPanel>
        {isViewCouncilData && (
          <TabPanel header={t('council.review.councilInfo')} leftIcon="pi pi-info-circle mr-2">
            <GeneralCouncilInfo councilId={councilId} projectProposalId={projectProposalId} />
          </TabPanel>
        )}
      </TabView>
    </>
  );
}
